import { cloneDeep } from "lodash";
import test_entry_config from "../config/test_entry_config.json";

function calculate85thPercentileN(array) {
  return Math.floor(array.length * 0.15);
}

export function calculatePdMapValuesAndGh(values, normalValues, indexesToBeRemoved) {
  const seventhMostPositiveElementIndex = calculate85thPercentileN(values);
  const ntdValues = values.map((v, i) => v - normalValues[i]);
  const trimmedValues = removeMultiple(cloneDeep(ntdValues), indexesToBeRemoved);
  trimmedValues.sort((a, b) => b - a);
  const eightyFifthPercentileMostPositiveElement = trimmedValues[seventhMostPositiveElementIndex];
  const eightyFifthPercentileMostPositiveElement2 =
    trimmedValues[seventhMostPositiveElementIndex + 1];
  const gh =
    eightyFifthPercentileMostPositiveElement * 0.8 +
    eightyFifthPercentileMostPositiveElement2 * 0.2;
  return {
    pdMapValues: ntdValues.map((v) => v - eightyFifthPercentileMostPositiveElement),
    gh,
  };
}

/**
 * Calculates pattern standard deviation according to the method given in
 * "A package for the statistical analysis of visual fields".
 *
 * @param npdRawValues
 */
export function calculatePatternStandardDeviation(npdRawValues) {
  const sum = npdRawValues.reduce((a, b) => a + b, 0);
  return Math.abs(sum / npdRawValues.length);
}

/**
 * Calculates mean deviation according to the method given in "A package
 * for the statistical analysis of visual fields".
 *
 * @param values
 * @param normalValues
 */
export function calculateMeanDeviation(values, normalValues) {
  const diff = values.map((v, i) => v - normalValues[i]);
  const sum = diff.reduce((a, b) => a + b, 0);
  return sum / diff.length;

  /*const len = values.length;
  const normalValuesMean = normalValues.reduce((a, b) => a + b, 0) / len;

  const diffValAndMean = values.map((v, i) => v - normalValues[i]);
  const oneOverVariance = values
    .map((v) => 1 / Math.abs(v - normalValuesMean))
    .filter((v) => !isNaN(v));
  const diffDividedByVariance = diffValAndMean
    .map((v, i) => v / Math.abs(values[i] - normalValuesMean))
    .filter((v) => !isNaN(v));

  const varianceReduced = oneOverVariance.reduce((a, b) => a + b, 0);
  const valueReduced = diffDividedByVariance.reduce((a, b) => a + b, 0);

  return ((1 / len) * valueReduced) / ((1 / len) * varianceReduced);*/
}

/**
 * Removes indexes given as an array from the input array.
 *
 * @param arr
 * @param toBeRemovedIndexes
 */
export function removeMultiple(arr, toBeRemovedIndexes: number[]) {
  const toBeRemovedSorted = toBeRemovedIndexes.sort();
  toBeRemovedSorted.forEach((val, i) => {
    arr.splice(toBeRemovedIndexes[i] - i, 1);
  });
  return arr;
}

export function getCumulativeSum(list) {
  const cumulativeSum = (
    (sum) => (value) =>
      (sum += value)
  )(0);
  return list.map(cumulativeSum);
}

export function getRingNoOfElement(
  cumulativeElementsInRowPadded,
  middleRow,
  middleCol,
  cumulativeElementsInRow,
  i,
  startIndexForElementsInRow,
) {
  return whichRing(middleRow, middleCol, cumulativeElementsInRow, i, startIndexForElementsInRow);
}

function whichRing(
  middleRow,
  middleCol,
  cumulativeElementsInRow,
  thresholdValInd,
  startIndexForElementsInRow,
) {
  let row = 0;
  let col = 0;
  let ring = 0;
  cumulativeElementsInRow.forEach((v, i) => {
    if (thresholdValInd >= v && thresholdValInd < cumulativeElementsInRow[i + 1]) {
      col = Math.ceil(
        Math.abs(thresholdValInd - v + startIndexForElementsInRow[i] - (middleCol + 0.5)),
      );
      row = Math.ceil(Math.abs(i - (middleRow + 0.5)));
      ring = Math.max(col, row);
    }
  });
  return ring;
}

export function getProbabilityPercentOfTheValueFromArray(
  inputArr,
  index,
  standardDeviations,
  percentagesStr,
) {
  const elem = inputArr[index];
  const sd = standardDeviations[index];
  const z = elem / sd;
  return getZPercent(z, percentagesStr);
}

export function getProbabilityPercentOfTheValue(
  input,
  normalVal,
  standardDeviation,
  percentagesStr,
) {
  const z = (normalVal - input) / standardDeviation;
  return getZPercent(z, percentagesStr);
}

export function getZPercent(z, percentagesStr) {
  //z == number of standard deviations from the mean

  //if z is greater than 6.5 standard deviations from the mean
  //the number of significant digits will be outside of a reasonable
  //range
  if (z < -6.5) return 0.0;
  if (z > 6.5) return 1.0;

  let factK = 1;
  let sum = 0;
  let term = 1;
  let k = 0;
  const loopStop = Math.exp(-23);
  while (Math.abs(term) > loopStop) {
    term =
      (((0.3989422804 * Math.pow(-1, k) * Math.pow(z, k)) / (2 * k + 1) / Math.pow(2, k)) *
        Math.pow(z, k + 1)) /
      factK;
    sum += term;
    k++;
    factK *= k;
  }
  sum += 0.5;

  if (percentagesStr === "percentages") {
    sum = sum * 100;
  }
  return sum;
}

export function getTestConfig(testType, testEye) {
  const c = test_entry_config["thresholdMap"][testType][testEye];
  return {
    emptyCellsIndex: c.emptyCellsIndex,
    middleCol: c.middleCol,
    middleRow: c.middleRow,
    pointsToIgnoreForPdMap: c.pointsToIgnoreForPdMap,
    angles: c.angleCoordinates,
  };
}
